module.exports = __webpack_public_path__ + "img/red-figure-active.5af54695.svg";